var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ios7_x5F_arrows_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "107.7,22.5 104,26.2 118,40.2 67.9,40.2 62.7,40.2 62.7,74.2 36.7,74.2 36.7,100.3 21,100.3 0.2,100.3  0.2,105.5 26.2,105.5 41.9,105.5 41.9,79.4 67.9,79.4 67.9,45.4 118,45.4 104,59.4 107.7,63.1 127.9,42.8  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_1_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_1_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.5,51l-4.4,3l12.5,11.3H77.8h-10V14.6L81.3,28l3.5-3.5L65.3,5L45.8,24.5l3.5,3.6l13.5-13.5v50.7h-10H9.1l13.7-12.1 l-4.3-2.9L0.2,66.6l18.2,16.3l4-3.7L12,70.3h38.3h12.5V123h5V70.3h12.6h37.1l-12.1,10.5l4.1,3.8l18.4-16.8L109.5,51z M7.6,66.6 L7.6,66.6L7.6,66.6L7.6,66.6z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_0_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,121.6l-18.5-18.5l16.6-0.4l0.1-4.5l-20.4,0.5v0l-4.5,0.1l-0.1,4.5h0l-0.5,20.4l4.5-0.1l0.4-18L64.1,128l25-25.1 l-3.2-3.2L64.1,121.6z M108.3,83.7L127.9,64l-23-23.1l-3.2,3.2L121.6,64l-16.4,16.5l-0.4-17.3l-4.5-0.1l0.5,20.4h0l0.1,4.5 l4.5,0.1v0l20.4,0.5l-0.1-4.5L108.3,83.7z M85.2,21.2L64.1,0L41.7,22.4l3.2,3.2l-0.5,0.5L64.1,6.4l18.1,18.2H64.9v4.5h20.3h4.5 v-4.5V4.2h-4.5V21.2z M32,40.5L31.9,36L7.1,35.1v4.9l16.7,0.4L0.2,64l24,24l3.2-3.2L6.6,64l21-21L28,60.9l4.5,0.1L32,40.5 L32,40.5z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_9_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_3_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "95.3,20.8 37.7,20.8 54.2,4.2 50,0 31.1,19 31.1,19 26.9,23.3 29.9,26.3 29.9,26.8 30.4,26.8 50,46.5 54.2,42.3  38.8,26.8 95.3,26.8 95.3,128 101.2,128 101.2,20.8  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_8_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_4_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.2,0 74,4.2 90,20.3 32.6,20.3 26.7,20.3 26.7,128 32.6,128 32.6,26.3 90,26.3 74,42.3 78.2,46.5 101.5,23.3  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_7_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_5_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "88.2,48.4 84,52.6 99.9,68.5 42.9,68.5 42.9,11.4 58.8,27.3 63,23.1 39.9,0 16.8,23.1 21,27.4 37,11.4 37,128  42.9,128 42.9,74.5 99.9,74.5 84,90.4 88.2,94.6 111.3,71.5  "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_6_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_6_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.6,88.8L126.4,54l-4.5-4.5L93.7,77.7V54.6c0-25.9-20.9-46.8-46.7-46.8c-25.8,0-46.7,21-46.7,46.8v65.6h6.2V54.6 C6.4,32.2,24.6,14,46.9,14c22.4,0,40.5,18.2,40.5,40.6v22.9L59,49.2l-4.5,4.5l31.6,31.6l0,0l4.5,4.5l0,0l0,0L91.6,88.8z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_5_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_7_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122,24L99.6,0L77.3,24l5.1,5.3l14.2-16.1c0,5,0,13.8,0,29.2c0,13.7-16,22.7-33,32.4C46.5,65,30.6,56.3,30.6,42.3 c0-15,0-23.7,0-28.8l13.8,15.8l5-5.3L27.3,0L5.1,24l3.9,5.7L24,13.4c0,5.1,0,13.8,0,28.9c0,17,16.9,27.1,35,37.5 c0.6,0.3,1.2,0.7,1.9,1.1V128h6.6V79.7c0.8-0.4,1.6-0.9,2.3-1.3c0,0,0,0,0,0c0,0,0,0,0,0c17.2-9.8,33.5-19.8,33.5-35.9 c0-15,0-23.7,0-28.8L118,29.7L122,24z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_4_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_8_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.8,53.3L30,49.5L-0.1,79.7l0,0l0,0L30,109.9l3.8-3.8L10,82.3h63.2v-5.2H10L33.8,53.3z M127.9,48.2L97.8,18.1l-3.8,3.8 l23.8,23.8h-63v5.2h63L94.1,74.8l3.8,3.8l30.1-30.1V48.2L127.9,48.2z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_3_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_9_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.5,25.6l-4.1,2.8l11.8,10.7H73.5L61.7,50.9L49.9,39.1H8.6l12.9-11.5l-4.1-2.7L0.2,40.3l17.2,15.4l3.8-3.5l-9.9-8.4 h36.2l11.8,11.9v47.4h4.7V55.7L76,43.8h42.1l-11.4,9.9l3.9,3.6l17.4-15.9L110.5,25.6z M7.2,40.3L7.2,40.3L7.2,40.3L7.2,40.3z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32__36_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.5,40.3l35.1-35.2L121.5,0L86.9,34.7L85.8,5.1l-7.7-2.6L80,47.5l44.1,1.2l-2.6-7.7L91.5,40.3z M3.5,77.3L6.1,85 l29.2,1.5L1.5,120.3l5.1,5.1l34.3-34.4l1,29.7l7.6,2.6l-1.6-43.7L3.5,77.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x31__36_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92,88.2l29.5-1.2l2.6-7.7l-44.8,1.9l-1.1,44.2l7.7-2.6l0.7-30.1l35.1,35.2l5.1-5.1L92,88.2z M40.4,36.4L6.6,2.6L1.5,7.7 L35.8,42L6.1,43l-2.6,7.6L47.1,49l2.4-44.4l-7.6,2.6L40.4,36.4z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_1_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_10_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.6,80.6l12.9,11.3c-4.5,0-11.9,0-24.3,0c-11.8,0-19.6-13.7-28.1-28.2c8.5-14.6,16.3-28.3,28.1-28.3 c12.9,0,20.5,0,24.9,0l-13.6,11.8l4.6,4.3l20.7-18.9l-20.8-19l-4.9,3.4l14.1,12.8c-4.4,0-11.9,0-25,0c-14,0-22.6,14.1-31.2,28.8 c-8.7-14.8-18.7-28.8-34.6-28.8c-11.4,0-17.9,0-21.5,0v5.7c3.6,0,10,0,21.1,0c14.5,0,23.5,13.7,32,28.3 c-8.5,14.5-17.5,28.2-32,28.2c-11.1,0-17.6,0-21.1,0v5.7c3.6,0,10.1,0,21.5,0c15.9,0,25.9-14,34.6-28.7 c8.5,14.7,17.1,28.7,31.1,28.7c13.9,0,21.6,0,25.8,0l-14.8,13.5l4.9,3.4l20.8-19.1l-20.7-19.1L102.6,80.6z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_0_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_11_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.7,97.2c0,5.2-4.2,9.5-9.5,9.5H30.9c-5.2,0-9.5-4.2-9.5-9.5V63.4l11.7,11.7l3.5-3.5L19.3,54.3l0,0l0,0l-2.5,2.6h0v0 L1.6,72.1l3.5,3.5L16.7,64v33.2c0,7.9,6.4,14.2,14.2,14.2h66.3c7.8,0,14.2-6.4,14.2-14.2V80.6h-4.7V97.2z M126.7,54.3l-3.5-3.5 l-11.8,11.8V30.8c0-7.9-6.4-14.2-14.2-14.2H30.9c-7.8,0-14.2,6.4-14.2,14.2V45h4.7V30.8c0-5.2,4.2-9.5,9.5-9.5h66.3 c5.2,0,9.5,4.2,9.5,9.5v31.8L94.9,50.8l-3.6,3.6l14.2,14.2l0,0l3.5,3.5l0,0l0,0l3.6-3.6l0,0L126.7,54.3z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_9_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_12_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.7,90.6L85.9,54.7l-4.5,4.5l28.1,28.2H50c-22.4,0-40.5-18.2-40.5-40.6S27.7,6.2,50,6.2V0C24.2,0,3.3,21,3.3,46.8 S24.2,93.6,50,93.6H110l-28.8,28.9l4.5,4.5l36.1-36.2l-0.1-0.1L121.7,90.6z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_8_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_13_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.1,0v6.2c22.4,0,40.5,18.2,40.5,40.6s-18.1,40.6-40.5,40.6H17.9l27.9-28l-4.5-4.5L5.5,90.8l0,0l0,0L41.5,127l4.5-4.5 L17.2,93.6h60.9c25.8,0,46.7-21,46.7-46.8S103.9,0,78.1,0z"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_7_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__28_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "126,15.2 121,13.9 111.6,49.1 76.4,39.6 75.1,44.7 115.2,55.4 115.2,55.4 115.3,55.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x32__27_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "54.6,80.2 18.8,68.4 18.8,68.4 13.8,66.8 0.8,106.9 5.8,108.6 17.1,73.5 53,85.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x31__27_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.2,18.3c21.8,0,40.1,15.3,44.7,35.7h5.2c-4.7-23.3-25.3-40.8-49.9-40.8c-23.7,0-43.7,16.3-49.3,38.3h5.3 C26.7,32.3,44.3,18.3,65.2,18.3z M65.2,110.2c-22.7,0-41.6-16.6-45.2-38.3h-5.2c3.7,24.6,24.8,43.4,50.4,43.4 c22.8,0,42.1-15,48.6-35.7h-5.4C102.2,97.4,85.2,110.2,65.2,110.2z"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_6_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_78_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.4,115.1L74.7,69.3l-5.3,5.3l45.7,45.8H86.6v7.5h33.8h7.5v-7.5V86.6h-7.5V115.1z M45.3,7.5V0H7.7H0.2v7.5v33.9h7.5 V12.9l45.7,45.8l5.3-5.3L13,7.5H45.3z M53.4,69.3L7.7,115.1V86.6H0.2v33.9v7.5h7.5h37.6v-7.5H13l45.7-45.8L53.4,69.3z M120.4,0 H86.6l-0.1,7.6l28.6,0L69.4,53.4l5.3,5.3l45.7-45.8v28.6h7.5V7.5V0H120.4z"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_5_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_14_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.4,82.8v32.3L74.7,69.3l-5.3,5.3l45.7,45.8H86.6v7.5h33.8h7.5v-7.5V82.8H120.4z M41.5,7.5V0H7.7H0.2v7.5v33.9 l7.5,0.1l0-28.6l45.7,45.8l5.3-5.3L13,7.5H41.5z"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_15_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.4,69.3L7.7,115.1V86.6H0.2v33.9v7.5h7.5h37.6v-7.5H13l45.7-45.8L53.4,69.3z M120.4,0H86.6l-0.1,7.6l28.6,0L69.4,53.4 l5.3,5.3l45.7-45.8v28.6h7.5V7.5V0H120.4z"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_16_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.3,43.3l-3.8,3.8l14.3,14.3H72v5.3h45.7l-14.3,14.3l3.8,3.8L127.9,64L107.3,43.3z M56.1,66.7v-5.3H10.4l16.1-16.2 l-3.8-3.8L0.2,64l20.7,20.7l3.8-3.8L10.4,66.7H56.1z M66.7,117.8V72h-5.3v45.8l-14.3-14.3l-3.8,3.8L64.1,128l22.5-22.6l-3.8-3.8 L66.7,117.8z M61.4,10.2V56h5.3V10.2L81,24.5l3.8-3.8L64.1,0L43.4,20.7l3.7,3.8L61.4,10.2z"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_17_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.7,7.1C45,7.1,23.2,24,16,47.2L7.2,14.5L1.5,16l12.1,44.8l0.1,0l0,0l45.1-12l-1.5-5.6l-37,9.8 c5-23,25.7-40.3,50.3-40.3c28.5,0,51.5,22.9,51.5,51.2c0,28.3-23.1,51.2-51.5,51.2c-17.6,0-33.1-8.8-42.4-22.1 c-0.3-0.4-0.9-1.3-0.9-1.3l-5.6,1.8c0,0,0.5,0.8,0.8,1.3c10.2,15.7,27.9,26.1,48.2,26.1c31.6,0,57.3-25.5,57.3-56.9 C127.9,32.6,102.3,7.1,70.7,7.1z"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_18_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.2,47.7l45.1,12.1l1.5-6.7l10.6-39.6l-5.6-1.5l-9,33.8c-7.6-22.8-29-39.2-54.3-39.2C25.8,6.6,0.2,32.3,0.2,64 c0,31.7,25.6,57.4,57.3,57.4c20.2,0,38-10.5,48.1-26.3c0.3-0.4,0.8-1.3,0.8-1.3l-5.6-1.8c0,0-0.6,0.9-0.9,1.3 c-9.3,13.5-24.8,22.3-42.4,22.3C29,115.6,5.9,92.5,5.9,64c0-28.5,23.1-51.6,51.5-51.6c23.9,0,44,16.3,49.8,38.4l-36.5-9.8 L69.2,47.7z"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_19_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7s58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M82.7,40 l-5.3-2.7L50.8,61.6V37.3h-5.3v53.3h5.3V66.4l26.6,24.2l5.3-3.6L56.1,64L82.7,40z"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_20_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64s63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7s58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M77.4,61.6 L50.8,37.3L45.4,41L72,64L45.4,88l5.3,2.7l26.6-24.2v24.2h5.3V37.3h-5.3V61.6z"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_21_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88,37.3L58.7,64L88,90.7l5.3-2.7L66.7,64l26.6-23L88,37.3z M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64 c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7 c32.3,0,58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M66.7,41l-5.3-3.6L32.1,64l29.3,26.7l5.3-2.7L40.1,64L66.7,41z"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_22_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.8,37.3L37.4,41l26.6,23L37.4,88l5.3,2.7L72,64L42.8,37.3z M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64 c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7 c32.3,0,58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M64.1,41l26.6,23L64.1,88l5.3,2.7L98.7,64L69.4,37.3L64.1,41z"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_23_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7c32.3,0,58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M72,37.3 L42.8,64L72,90.7l5.3-2.7L52.8,64l24.6-23L72,37.3z"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_24_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7c32.3,0,58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M50.7,41 l26.6,23L50.8,88l5.3,2.7L85.4,64L56.1,37.3L50.7,41z"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_25_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,87.9L64.1,87.9l30.8-30.7L91,53.4L66.7,77.7V21.3h-5.3v56.4L37.1,53.4l-3.8,3.8L64.1,87.9L64.1,87.9z M64.1,0 C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7s58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M29.5,98.7h69.2 v-5.3H29.5V98.7z"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_26_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.7,45.3L66.7,45.3l-2.6-2.6l0,0l0,0l-2.6,2.6h0v0L33.3,73.5l3.8,3.8L61.4,53v56.3h5.3V53l24.2,24.3l3.8-3.8L66.7,45.3 L66.7,45.3z M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64s63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7s58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M29.5,37.3h69.2 V32H29.5V37.3z"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_27_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.7,9.3V70h4.8V9.3l22,22.1l3.5-3.5L64.2,0l-0.1,0.1L64,0L36.2,27.9l3.5,3.5L61.7,9.3z M83.3,38.6v4.8h33.8v79.7H11 V43.5h33.8v-4.8H6.2V128h115.7V38.6H83.3z"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_28_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.6,113.4H4.7V14.6h82.9V46h4.5V10.1H0.2v107.8h91.9V82h-4.5V113.4z M125.4,61.2l-21-23.1l-3.2,3.2l19.5,20.4H63.1v4.5 h57.8l-19.8,22.4l3.2,3.2l21.2-25.1l2.4-2.9L125.4,61.2z"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_29_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.8,66.2v-4.4H8.7l20.1-20.1l-3.2-3.2L0.2,64l0,0l0,0l25.4,25.5l3.2-3.2L8.7,66.2H61.8z M37.6,11v35.3H42V15.4h81.5 v97.1H42V81.7h-4.4V117h90.3V11H37.6z"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "_x39__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_30_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,0v87.7h37.9V83H12V4.7h104.1V83H83v4.7h37.9V0H7.3z M66.4,118.9v-62h-4.7v62L40.1,97.2l-3.4,3.4L64,128l0.1-0.1 l0.1,0.1l27.3-27.4L88,97.2L66.4,118.9z"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "_x38__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_31_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.4,33.8l-46,46.1V45H39v43.5h0.5h5h38.4v-5.4H48.8l45.4-45.5L90.4,33.8z M109.2,18.7c-24.9-25-65.4-25-90.3,0 c-24.9,25-24.9,65.5,0,90.5c24.9,25,65.4,25,90.3,0C134.2,84.3,134.2,43.7,109.2,18.7z M105.5,105.5c-22.9,22.9-59.9,22.9-82.8,0 c-22.9-22.9-22.9-60.1,0-83c22.9-22.9,59.9-22.9,82.8,0C128.3,45.4,128.3,82.6,105.5,105.5z"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "_x37__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_32_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.1,79.3L37.7,33.8L34,37.6l45.4,45.5H45.1v5.4h38h5.4v-5.4V45h-5.4V79.3z M109.2,18.7c-24.9-25-65.4-25-90.3,0 c-24.9,25-24.9,65.5,0,90.5c24.9,25,65.4,25,90.3,0C134.2,84.3,134.2,43.7,109.2,18.7z M105.5,105.5c-22.9,22.9-59.9,22.9-82.8,0 c-22.9-22.9-22.9-60.1,0-83c22.9-22.9,59.9-22.9,82.8,0C128.3,45.4,128.3,82.6,105.5,105.5z"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "_x36__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_33_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.2,18.7c-24.9-25-65.4-25-90.3,0c-24.9,25-24.9,65.5,0,90.5c24.9,25,65.4,25,90.3,0 C134.2,84.3,134.2,43.7,109.2,18.7z M105.5,105.5c-22.9,22.9-59.9,22.9-82.8,0c-22.9-22.9-22.9-60.1,0-83 c22.9-22.9,59.9-22.9,82.8,0C128.3,45.4,128.3,82.6,105.5,105.5z M83,44.9v-5.4H45h-5.4v5.4V83H45V48.7l45.4,45.5l3.8-3.8 L48.8,44.9H83z"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "_x35__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_34_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.2,18.7c-24.9-25-65.4-25-90.3,0c-24.9,25-24.9,65.5,0,90.5c24.9,25,65.4,25,90.3,0 C134.2,84.3,134.2,43.7,109.2,18.7z M105.5,105.5c-22.9,22.9-59.9,22.9-82.8,0c-22.9-22.9-22.9-60.1,0-83 c22.9-22.9,59.9-22.9,82.8,0C128.3,45.4,128.3,82.6,105.5,105.5z M45.1,39.5v5.4h34.2L34,90.4l3.8,3.8l45.4-45.5V83h5.4V44.9 v-5.4h-5.4H45.1z"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "_x34__1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_35_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7c32.3,0,58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z  M63.8,28.8L63.8,28.8L33.1,59.5l3.8,3.8l24.5-24.5V104h5.3V39.4l24,24l3.8-3.8L63.8,28.8L63.8,28.8z"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "_x33__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_36_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.4,33.5l-3.8,3.8L89.2,62H24.1v5.3h64.3L64.6,91.3l3.8,3.8l30.7-30.8l-0.1-0.1l0.1-0.1L68.4,33.5z M64.1,0 C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7c32.3,0,58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "_x32__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_37_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,37l-3.8-3.8L29.5,64l0,0l0,0l30.7,30.8L64,91L39.8,66.7H104v-5.3H39.8L64,37z M64.1,0C28.8,0,0.2,28.7,0.2,64 c0,35.3,28.6,64,63.9,64c35.3,0,63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7C31.7,122.7,5.5,96.4,5.5,64 c0-32.4,26.2-58.7,58.6-58.7s58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "_x31__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_38_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,0C28.8,0,0.2,28.7,0.2,64c0,35.3,28.6,64,63.9,64s63.9-28.7,63.9-64C127.9,28.7,99.3,0,64.1,0z M64.1,122.7 C31.7,122.7,5.5,96.4,5.5,64c0-32.4,26.2-58.7,58.6-58.7s58.6,26.3,58.6,58.7C122.6,96.4,96.4,122.7,64.1,122.7z M66.7,88.5V24 h-5.3v64.5L37.1,64.2l-3.8,3.8L64,98.8l0.1-0.1l0.1,0.1l30.7-30.8L91,64.2L66.7,88.5z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowIcon.8150eb01.svg";
export { ForwardRef as ReactComponent };